
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.499 22.004v-2M15.502 22.004v-2"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M16.767 22.004H7.233a2.001 2.001 0 01-1.989-2.222l.358-3.222A4.002 4.002 0 019.58 13h4.842a4.002 4.002 0 013.982 3.56l.358 3.222a2.001 2.001 0 01-1.994 2.222v0zM12 1.996v0a1.5 1.5 0 011.5 1.5V9.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V3.496a1.5 1.5 0 011.5-1.5z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M14.25 13h-4.5a1 1 0 01-.924-1.385l.417-1a1 1 0 01.923-.616h3.668a1 1 0 01.923.615l.417 1A1 1 0 0114.251 13z"}}),_c('path',{attrs:{"d":"M12 22.004v-2"}})])
          )
        }
      }
    